import axios from 'axios';
import router from '../router';
import Client from '@/assets/scripts/client';

import { sg } from '@/config/common.js'
import { generateRandomString, getQueryParams } from '@/utils/common.js'
import { SignatureUtil } from '@/utils/sign.js'
import { Toast } from 'vant';
import { isRelease } from '@/utils/config.js'

const config = require('./config.js');

const language = Client.getAppInfoLang();

const { version, channel, deviceType, appPackageName, deviceId, timeZone } = Client.getAppInfo();

// 按包名取baseUrl
const baseURL = `https://${config[`apiBaseURL${config.packageNameMap[appPackageName]}`] || config.apiBaseURLvava}`;
const tempUrl = '/'
const service = axios.create({ baseURL: isRelease ? baseURL : tempUrl, timeout: 30000 });
service.interceptors.request.use(
  config => {
    const { uid, token } = Client.getUserBaseInfo()

    const signObj = {
      timestamp: '',
      nonce: '',
      authorization: '',
    }

    try {
      let appSecret = appPackageName ? sg[appPackageName] : ''
      let apiPath = config.url.replace(/\?.*$/, '') || ''
      let businessParams = {}

      // 浏览器场景 没有appPackageName deviceId
      if (Client.env.isBrowser) {
        appSecret = isRelease ? sg['com.qumi.h5'] : sg['com.example.h5']
      }
      if (config.data) {
        businessParams = { ...config.data }
      }
      if (config.params) {
        businessParams = { ...config.params, ...businessParams }
      }
      const queryObj = getQueryParams(config.url)
      if (queryObj && Object.keys(queryObj).length) {
        businessParams = { ...queryObj, ...businessParams }
      }

      signObj.timestamp = Date.now()
      signObj.nonce = generateRandomString(8)
      signObj.authorization = SignatureUtil.genSignature(appPackageName, deviceId, apiPath, signObj.timestamp, signObj.nonce, appSecret, businessParams)
    } catch (err) {
      console.log('try catch', err)
    }

    const headers = {
      channel: channel || '',
      version: version || '',
      // 0 安卓 1 IOS
      deviceType: deviceType || 0,
      appPackageName: appPackageName || '',
      deviceId: deviceId || '',
      language: language || '',
      timeZone: timeZone || '',
      uid: uid || '',
      token: token || '',
      platform: 'h5',
      ...signObj
    };

    // 本地调试代码
    if (window.location.hostname === 'localhost') {
      headers.version = '4.2.7'
      headers.deviceType = deviceType || 0
      headers.appPackageName = appPackageName || 'com.example.gcc'
      headers.deviceId = deviceId || "9b7cdeac-9ea6-4467-b9c8-d94bdc690d4d"
      headers.language = language || 'en'
      headers.timestamp = ''
      headers.nonce = ''
      headers.authorization = ''
    }

    config.headers = headers;

    return config;
  },
  error => {
    return Promise.reject(error)
  }
)

// response
const noToastApi = ['/api/v2/app/withdraw/wallet/0/apply/check', '/api/v2/app/withdraw/wallet/1/apply/check']
service.interceptors.response.use(
  response => {
    Toast.clear();

    const res = response.data;

    // todo - 前端配置中未发现有地方设置noResData
    if (response.config.noResData) {
      return res
    }

    if (res.status == 2013) {
      router.replace('/certification')
      return
    }

    // 异常status
    if (res.status !== 200) {
      if (res.error.status == 694) {
        return res.data || res
      }

      // 异常toast (具体根据接口地址判断)
      const errorUrl = ((response || {}).config || {}).url || ''
      if (!noToastApi.includes(errorUrl)) {
        Client.showToast(((res || {}).error || {}).description || 'Network error')
      }
      return res.data || res;
    }
    // 正常status
    else {
      return res.data || res;
    }
  },
  error => {
    Client.showToast('Network error')
    return Promise.reject(error)
  }
)

export default service
